import * as api from '@owl-nest/api-client/next'

type ListConfig = {
  getParams?: URLSearchParams
  withToken?: boolean
}

export async function list(
  projectId: number | string,
  config: ListConfig = {},
): Promise<api.HttpResult<api.ReferralListPage>> {
  const response = await api.client('GET /projects/:id/referrals', {
    urlParams: { id: String(projectId) },
    getParams: config.getParams,
    withToken: config.withToken,
  })

  return response.next((success) => success.body)
}
